import { render, staticRenderFns } from "./HistoryComponent.vue?vue&type=template&id=5df37372&scoped=true&"
import script from "./HistoryComponent.vue?vue&type=script&lang=js&"
export * from "./HistoryComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5df37372",
  null
  
)

export default component.exports